import styled from 'styled-components';
import { Box } from '@mui/material';

export const CountryDataList = styled(Box)`

.countryList{
    margin-top: 30px;
    h3{
        margin-left:30px;
        text-align:left;
        color: rgb(27, 74, 131);
        font-size: 18px;
        font-weight: 500;
    }
    .d-flex{
        margin-left:30px;
        border: 1px solid #1B4A83;
            padding: 20px 36px;
                justify-content: space-between;
        flex-wrap: wrap;
        width: 90%;
    border-radius: 5px;
    .product{
        width: 100%;
    }
    .firstrow
    {
        width: 5%;
        color:#1B4A83;
    }
    .productrow
    {
        width:10px;
    }
    }
         
}

`;

          